import type { ReactNode } from 'react';
import {
  Calendar,
  CheckSquare,
  FileText,
  MapPin,
  MessagesSquare,
  Store,
  Users,
} from 'lucide-react';
import { SearchResultType, isSearchResultType } from '@peles/shared';

/** The icon drawn beside each kind's results in quick search. */
export const SEARCH_TYPE_ICONS: Record<SearchResultType, ReactNode> = {
  [SearchResultType.Event]: <Calendar size={16} />,
  [SearchResultType.Vendor]: <Store size={16} />,
  [SearchResultType.Venue]: <MapPin size={16} />,
  [SearchResultType.Guest]: <Users size={16} />,
  [SearchResultType.Task]: <CheckSquare size={16} />,
  [SearchResultType.File]: <FileText size={16} />,
  [SearchResultType.Conversation]: <MessagesSquare size={16} />,
};

/** A kind's icon; a kind the server added before this build knows it gets a plain document. */
export function searchTypeIcon(type: string): ReactNode {
  return isSearchResultType(type) ? SEARCH_TYPE_ICONS[type] : <FileText size={16} />;
}
